import { useState, useEffect, useCallback } from "react";
import { supabase } from "@/lib/supabase";

const LOGO_PATH = "logo/site-logo";
const DEFAULT_LOGO = "https://readdy.ai/api/search-image?query=Modern%20sports%20streaming%20TV%20logo%20design%20for%20World%20Cup%20TV%20brand%2C%20sleek%20minimalist%20icon%20with%20soccer%20ball%20and%20play%20button%20motif%2C%20dark%20theme%20compatible%20with%20vibrant%20accent%20highlights%2C%20professional%20broadcast%20studio%20aesthetic%2C%20clean%20geometric%20shapes%2C%20high%20contrast%20flat%20design%2C%20esports%20sports%20branding%20style&width=512&height=512&seq=worldcuptv-logo-01&orientation=squarish";

export function useSiteLogo() {
  const [logoUrl, setLogoUrl] = useState(DEFAULT_LOGO);
  const [loading, setLoading] = useState(true);

  const fetchLogo = useCallback(async () => {
    try {
      const { data } = supabase.storage
        .from("admin-assets")
        .getPublicUrl(LOGO_PATH);

      if (data?.publicUrl) {
        setLogoUrl(data.publicUrl);
      }
    } catch {
      // use default
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchLogo();
  }, [fetchLogo]);

  return { logoUrl, loading, refetch: fetchLogo };
}